module.exports = __webpack_public_path__ + "img/145.1cb7386d.jpg";